<template>
	<div
		:id="`link-list-${_uid}`"
		:class="[
			'c-block-list-link-list-custom',
			'w-5col >=768:w-8col max-w-full mx-auto',
		]"
	>
		<LongReadTarget
			v-if="title"
			:container-id="`link-list-${_uid}`"
			:title="title"
		>
			<BaseH2 class="text-primary-button mb-sm" v-text="title" />
		</LongReadTarget>

		<div
			v-if="links && links.length"
			class="bg-primary-light rounded-lg p-md"
		>
			<LinkTile
				v-for="(link, index) in links"
				:key="index"
				:aria-labelledby="`link-${_uid}-${index}`"
				:target="link.target"
				class="group relative flex justify-between pb-sm last:pb-0"
				:to="link.url ? link.url : ''"
			>
				<BaseH3 :id="`link-${_uid}-${index}`">{{ link.name }}</BaseH3>
				<BaseButton tag="div" class="w-fit ml-8">
					<template #icon>
						<div class="w-16 h-16 flex justify-center items-center">
							<SvgExternalArrowIcon
								v-if="link.target === '_blank'"
								class="w-12 h-12 text-white"
							/>
							<SvgArrowIcon v-else class="w-14 h-12 text-white" />
						</div>
					</template>
				</BaseButton>
			</LinkTile>
		</div>
	</div>
</template>

<script>
import LinkTile from '~/citi-baseline/components/LinkTile';
import LongReadTarget from '~/citi-baseline/components/LongReadTarget';
import SvgArrowIcon from '~/assets/svgs/arrow-icon.svg?inline';
import SvgExternalArrowIcon from '~/assets/svgs/external-arrow-icon.svg?inline';

export default {
	name: 'BlockListLinkListCustom',

	components: {
		LinkTile,
		LongReadTarget,
		SvgExternalArrowIcon,
		SvgArrowIcon,
	},

	inheritAttrs: false,

	props: {
		title: String,
		links: Array,
	},
};
</script>
